











































import Vue from "vue";
import Component from "vue-class-component";
import { Company } from "../../api/personnel/company";
import { Specialty } from "../../api/personnel/specialty";
import { StringHelpers } from "../../api/helpers/StringHelpers";
import { personnel } from "../../api/personnel/personnel";
import { Prop } from "vue-property-decorator";
import { WOSpecialty } from "../../api/personnel/wospecialty";
import * as nodemailer from 'nodemailer'; 
@Component({
  name: "AddPersonnel"
})
export default class AddPersonnel extends Vue {
  public companyList: any[] = [];
  public specialtyList: any[] = [];
  public firstname: string = "";
  public lastname: string = "";
  public mobile: string = "";
  public landline: string = "";
  public email: string = "";
  public specialty: string = "";
  public company: string = "";
  public WoSpecialty: string = "";
  public WOSpecialtyList: any[] = [];
  public row: number = -1;
  public id: number = -1;
  public transporter: any = "";
  public mailOptions: any = "";
  public checked:boolean = true;
  public active:boolean = true;
  public CheckEdit(person: any) {
    console.log(this.specialtyList);
    console.log(this.companyList);
    //console.log('person--------->'+JSON.stringify(person))
    if (person.id != undefined) {
      this.firstname = person.firstname;
      this.lastname = person.lastname;
      if (person.mobile != "null") {
        this.mobile = person.mobile;
      }
      if (person.landline != "null") {
        this.landline = person.landline;
      }
      if (person.email! != "null") {
        this.email = person.email;
      }
      this.specialty = person.specialty_id;
      this.company = person.company_id;
      this.id = person.id;
      this.active = person.active
      this.WoSpecialty = person.wo_specialty;
      this.checked=person.active
    }
  }
    // public mail(){
    // this.transporter = nodemailer.createTransport(`smtps://lydia.afentaki@lass.gr:697309117lydia.afentaki@lass.gr`); 
 
    //  this.mailOptions = { 
    //   from : 'lydia.afentaki@lass.gr', 
    //   to : 'lydia.afentaki@lass.gr', 
    //   subject : 'Hello', 
    //   text: 'Hello from node.js' 
    // }; 
 
    // this.transporter.sendMail( this.mailOptions, (error, info) => { 
    //   if (error) { 
    //     return console.log(`error: ${error}`); 
    //   } 
    //   console.log(`Message Sent ${info.response}`); 
    // }); 
    //   }
 
  public back() {
    this.$store.dispatch("updateCurrentObject", undefined);
    this.$store.dispatch("updateCurrentComponent", "PersonnelList");
    this.$store.dispatch("setCurrentId", -1);
    this.$router.replace({ name: "load" });
  }
  public activepersonnel(){

        this.checked= true  
  }
 public inactivepersonnel(){
     
        this.checked= false 
  }
  public async getSpecialtyList() {
    Specialty.getAllSpecialties(
      this.$store.getters.getToken,
      this.$store.getters.getHost
    ).then(response => {
      response.json().then(resp => {
        this.specialtyList = JSON.parse(JSON.stringify(resp));
        this.getCompanyList();
      });
    });
  }
  public async getCompanyList() {
    Company.getAllCompanies(
      this.$store.getters.getToken,
      this.$store.getters.getHost
    ).then(response => {
      response.json().then(resp => {
        this.companyList = JSON.parse(JSON.stringify(resp));
        this.getWOSpecialtyList();
      });
    });
  }
  public async getWOSpecialtyList() {
    WOSpecialty.getAllWOSpecialties(
      this.$store.getters.getToken,
      this.$store.getters.getHost
    ).then(response => {
      response.json().then(resp => {
        this.WOSpecialtyList = JSON.parse(JSON.stringify(resp));
        this.CheckEdit(this.row);
      });
    });
  }
  public mounted() {
    this.row = this.$store.getters.getCurrentObject;
    this.getSpecialtyList();
  }
    // data() {
    //   return {
    //     checked: true
    //   };
    // }
  public async addToDB() {
    if (this.id === -1) {
      let personnelItem = {
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        mobile: this.mobile,
        landline: this.landline,
        company_id: this.company,
        specialty_id: this.specialty,
        active: this.checked,
        //active: true,
        wo_specialty: this.WoSpecialty
      };
      await personnel.addNewStaff(
        this.$store.getters.getToken,
        personnelItem,
        this.$store.getters.getHost
      );
    } else {
      let personnelItem = {
        firstname: this.firstname,
        lastname: this.lastname,
        email: this.email,
        mobile: this.mobile,
        landline: this.landline,
        company_id: this.company,
        specialty_id: this.specialty,
        active: this.checked,
        //active: true,
        id: this.id,
        wo_specialty: this.WoSpecialty
      };
      await personnel.editStaff(
        this.$store.getters.getToken,
        personnelItem,
        this.$store.getters.getHost
      );
    }
    this.$store.dispatch("updateCurrentObject", undefined);
    this.$store.dispatch("updateCurrentComponent", "Welcome");
    this.$store.dispatch("setCurrentId", -1);
    this.$router.replace({ name: "load" });
  }
}
